import { LitElement, html, css } from 'lit';
import importedCog from '../assets/svg/cog.svg';
import importedStackedBlocks from '../assets/svg/stacked-blocks.svg';
import '../cbom-product/CbomProduct';
import '../cbom-category/CbomCategory';

const cog = `data:image/svg+xml;base64,${btoa(importedCog)}`;
const stackedBlocks = `data:image/svg+xml;base64,${btoa(
  importedStackedBlocks
)}`;

class CbomConfigurator extends LitElement {
  // Properties
  static properties = {
    name: {},
    open: { type: Boolean },
    isMobile: { type: Boolean },
    isLoading: { type: Boolean },
    feedback: { type: String },
  };

  // Styles
  static styles = css`
    h2 {
      align-items: center;
      display: flex;
      cursor: default;
      font-size: 15px;
      line-height: 30px;
      font-family: Arial, sans-serif;
      color: #434649;
      position: relative;
      margin: 0;
    }

    .stacked-blocks {
      margin-right: 12px;
    }

    .is-mobile-and-open {
      border: 1px solid rgb(229, 229, 229);
      border-top: none;
      display: block;
      border-bottom-left-radius: 4px;
      border-bottom-right-radius: 4px;
    }

    .is-product-detail-card-inner {
      margin-left: 44px;
    }

    .is-mobile-and-open .is-product-detail-card-inner {
      margin-left: 0;
    }

    @keyframes spinAnim {
      from {
        transform: translate(-50%, -50%) rotate(0deg);
      }
      to {
        transform: translate(-50%, -50%) rotate(360deg);
      }
    }

    .spinner-container {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100%;
      width: 100%;

      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      border-radius: 4px;
      opacity: 1;
      background: rgb(204 204 204 / 50%);
      z-index: 1;
    }

    .spinner {
      width: 32px;
      height: 32px;
      background-repeat: no-repeat;
      animation: spinAnim 1.2s infinite linear;
      transform-origin: 50% 50%;
    }

    .feedback {
      padding: 10px;
      font-family: Arial;
      font-size: 14px;
      border: 1px solid #d00600;
      color: #d00600;
      border-radius: 4px;
      background: rgb(208 6 0 / 10%);
      margin: 12px 0;
    }

    .is-mobile-and-open .feedback {
      margin-top: 3px;
      margin-left: 12px;
      margin-right: 12px;
    }
  `;

  render() {
    if (this.open) {
      let title;
      if (!this.isMobile) {
        title = html`<h2>
          <img class="stacked-blocks" src=${stackedBlocks} alt="" />
          <span class="heading-name">${this.name}</span>
        </h2>`;
      }

      const configuratorIsMobileAndOpenClass =
        this.open && this.isMobile ? 'is-mobile-and-open ' : '';

      return html`
        <style>
          .spinner {
            background: url(${cog}) center / 32px;
          }
        </style>
        <div class="${configuratorIsMobileAndOpenClass}is-product-detail-card">
          ${this.feedback
            ? html`<div class="feedback">${this.feedback}</div>`
            : null}
          ${this.isLoading
            ? html`<div class="spinner-container">
                <div class="spinner"></div>
              </div>`
            : null}
          ${title}
          <div class="is-product-detail-card-inner">
            <slot></slot>
          </div>
        </div>
      `;
    }
  }
}

customElements.define('cbom-configurator', CbomConfigurator);
